import { makeVaultRawRequest, throwVaultError } from '../helpers';

export async function fetchSrtApi(srtPath: string): Promise<string> {
  const res = await makeVaultRawRequest({
    method: 'GET',
    path: `/vault/srt?path=${encodeURIComponent(srtPath)}`,
  });
  if (!res.ok) {
    await throwVaultError(res);
  }
  return res.text();
}
